import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GithubProfileData from './githubProfileData';

const Testdata = () => {
  const [searchParams] = useSearchParams();
  const username = searchParams.get('user') || 'dev-girii'; // Default username
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await GithubProfileData({ username, onDataFetched: setProfileData });
      setProfileData(data);
    };

    fetchData();
  }, [username]); // Fetch new data when the username changes

  return (
    <div>
      {profileData ? <pre style={{display:"none"}}>{JSON.stringify(profileData, null, 2)}</pre> : <p style={{display:"none"}}>Loading...</p>}
    </div>
  );
};

export default Testdata;
